import { useEffect, useRef } from "react"
import { X } from "lucide-react"
import { VizagAgenda } from "./VizagAgenda"

export function VizagAgendaModal({ open, onClose, returnFocusRef }) {
  const dialogRef = useRef(null)
  const closeRef = useRef(null)

  useEffect(() => {
    if (!open) return
    const dialog = dialogRef.current
    const trigger = returnFocusRef.current || document.activeElement
    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = "hidden"
    // Native modal dialogs keep keyboard focus inside and make the page inert.
    dialog.showModal()
    closeRef.current?.focus({ preventScroll: true })
    return () => {
      if (dialog.open) dialog.close()
      document.body.style.overflow = previousOverflow
      const target = trigger?.isConnected && trigger !== document.body
        ? trigger
        : document.querySelector('[aria-label="Toggle mobile menu"]')
      target?.focus({ preventScroll: true })
    }
  }, [open, returnFocusRef])

  if (!open) return null

  return (
    <dialog
      ref={dialogRef}
      aria-labelledby="agenda-dialog-heading"
      aria-modal="true"
      className="m-auto max-h-[90vh] w-[calc(100%_-_1rem)] max-w-6xl overflow-hidden rounded-2xl border border-green-100 bg-white p-0 shadow-2xl backdrop:bg-black/60 backdrop:backdrop-blur-sm sm:w-[calc(100%_-_3rem)] sm:rounded-3xl supports-[height:100dvh]:max-h-[90dvh]"
      onCancel={(event) => { event.preventDefault(); onClose() }}
      onClick={(event) => {
        if (event.target !== event.currentTarget) return
        const bounds = event.currentTarget.getBoundingClientRect()
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) onClose()
      }}
    >
      <div className="flex max-h-[90vh] flex-col supports-[height:100dvh]:max-h-[90dvh]">
        <div className="flex shrink-0 items-center justify-between gap-3 border-b border-green-100 bg-white px-4 py-3 sm:px-6">
          <h2 id="agenda-dialog-heading" className="text-base font-bold text-green-900 sm:text-lg">CTS 2026 Vizag Agenda</h2>
          <button ref={closeRef} type="button" onClick={onClose} aria-label="Close agenda" className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-green-800 hover:bg-green-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-green-700">
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        </div>
        <div className="min-h-0 overflow-y-auto overscroll-contain">
          <VizagAgenda />
        </div>
      </div>
    </dialog>
  )
}
